import { render, staticRenderFns } from "./setrole.vue?vue&type=template&id=5bbeb8cb&scoped=true&"
import script from "./setrole.vue?vue&type=script&lang=js&"
export * from "./setrole.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5bbeb8cb",
  null
  
)

export default component.exports